import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import { partial } from '../../../utils/';

import * as actions from '../inspection.actions';
import {
  getInspectionsForBrandType,
  getNewInspectionTitleForBrandType,
} from '../../inspectionType/inspectionType.selectors';

import { ListItem, ListItemText } from 'material-ui/List';
import { PageAppBar } from '../../core/components/';
import { PinnedSubHeaderList } from '../../common/components/list';

const styles = theme => ({
  text: {
    color: theme.palette.primary[500],
    fontSize: 16,
  },
  root: {
    backgroundColor: theme.palette.background.default,
  },
});

class ModelSelectList extends Component {
  componentDidMount = () => {
    const { readInspectionTypes } = this.props;
    readInspectionTypes();
  };

  onItemSelect = (brandId, typeId, inspectionId) => {
    const { createInspection, generateInspectionId, history } = this.props;
    const inspectionType = `${brandId}.${typeId}.${inspectionId}`;
    const { id } = generateInspectionId(inspectionType);
    createInspection(
      {
        type: inspectionType,
      },
      id
    );
    history.push(`/inspection/edit/${id}/perustiedot`);

    //history.push(`/inspection/${tempInspection.payload.tempId}`);
    //    promise.then(action => {
    //   history.push(`/inspection/${action.response.result}`);
    //  })
    // .catch(error => {});
  };

  renderItem = (item, index) => {
    const { classes } = this.props;
    const { brandId, typeId } = this.props;
    return (
      <ListItem button key={item.key} onClick={partial(this.onItemSelect, brandId, typeId, item.key)}>
        <ListItemText
          primary={`${item.label}`}
          classes={{
            text: classes.text,
          }}
        />
      </ListItem>
    );
  };

  render() {
    const { backPath, inspections, brandTypeTitle, classes } = this.props;
    for (let index = 0; index < inspections.length; index++) {
      if (!inspections[index].isActive) {
        inspections.splice(index, 1)
        index = index - 1
      }
    }
    const title = `Uusi raportti: ${brandTypeTitle}`;
    return (
      <div className={classes.root}>
        <PageAppBar title={title} backPath={backPath} />
        <PinnedSubHeaderList title="Valitse tuoteryhmä" items={inspections} renderItem={this.renderItem} />
      </div>
    );
  }
}

ModelSelectList.propTypes = {
  backPath: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  createInspection: PropTypes.func.isRequired,
  generateInspectionId: PropTypes.func.isRequired,
  readInspectionTypes: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  inspections: PropTypes.array.isRequired,
  brandId: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
  brandTypeTitle: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { match }) => {
  const { params: { brandId, typeId } } = match;
  const inspections = getInspectionsForBrandType(state, brandId, typeId) || [];
  const brandTypeTitle = getNewInspectionTitleForBrandType(state, brandId, typeId);
  const online = state.offline.online;
  return {
    online,
    inspections,
    brandId,
    typeId,
    brandTypeTitle,
  };
};

export default connect(mapStateToProps, Object.assign({}, actions))(withStyles(styles)(ModelSelectList));



// WEBPACK FOOTER //
// ./src/modules/inspection/components/ModelSelectList.js